/**
 * O intervalo seguinte de um polling com backoff exponencial, sem passar do máximo.
 *
 * @example
 * intervalo = proximoIntervaloComBackoff(intervalo, 1.5, 10_000);
 */
export function proximoIntervaloComBackoff(atual: number, fator: number, maximo: number): number {
  return Math.min(atual * fator, maximo);
}
